import { render, staticRenderFns } from "./didNumber.vue?vue&type=template&id=1b3d8966&"
import script from "./didNumber.vue?vue&type=script&lang=js&"
export * from "./didNumber.vue?vue&type=script&lang=js&"
import style0 from "./didNumber.vue?vue&type=style&index=0&id=1b3d8966&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports